module.exports = __webpack_public_path__ + "static/media/car_button_03.4d406387.png";